export default function convertTitleObject(objects: any[], t: Function) {
	return objects.map(item => {
		const translatedObject: Record<string, any> = {};

		Object.entries(item).forEach(([key, value]) => {
			translatedObject[t(key)] = value;
		});

		return translatedObject;
	});
}
